const Cmtpax = (state) => state.Cmtpax

export default {
  Cmtpax
}
